import { getSportingChatURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { appendFormDataWithObjectValues } from 'utils/appendFormDataWithObjectValues';
import { SportingSecureParams } from 'services/sporting/types';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  idMessage: number;
  message: string;
};

export const editMessage = async (
  params: SportingSecureParams<Payload>
): Promise<void> => {
  const { payload } = params;

  const endpointURL = getSportingChatURL('editMessage');

  const headers = createSportingHeaders();

  const body = new FormData();
  appendFormDataWithObjectValues(body, payload);

  const response = await customFetch(endpointURL, {
    method: 'PUT',
    headers,
    body
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
